import { useState, useEffect } from "react";

function getStorageValue(key: string, defaultValue: string | null) {
  // getting stored value
  const saved = localStorage.getItem(key);

  if (!saved){
    return defaultValue;
  }

  const initial = JSON.parse(saved ?? "");
  return initial || defaultValue;
}

export const useLocalStorage = (key: string, defaultValue: string | null) => {
  const [value, setValue] = useState(() => {
    return getStorageValue(key, defaultValue);
  });

  useEffect(() => {
    // storing input name
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};

export const StorageKeys = Object.freeze({
   licenseKey: "licenseKey"
})